export default { sha: '7806ca876fd96e4ab8c0e5a7634f6135484b5ca1', buildNumber: 'undefined' }
